import React, { useEffect } from 'react';

import { EditProfile } from './EditProfile';

import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import {
  dateTimeConstants,
  DENIED_STATUS,
  insuranceCheckStatus,
} from '_constants';

import { formatDate } from '_helpers/helpers';

import moment from 'moment';

const DriverQualificationsComponent = ({
  profileData,
  refetchUser,
  isOpen,
  toggleAccordion,
  permList,
  authUser,
}) => {
  return (
    <div
      id="driver-qualifications"
      className={`profile-data__drops profile-data_comp ${isOpen ? 'is-active' : ''}`}
    >
      <header onClick={() => toggleAccordion('#driver-qualifications')}>
        <button type="button">
          <h3>Driver Qualifications</h3>
        </button>
      </header>
      <div className="profile-data__drops-cnt">
        <ul role="list">
          <li class="accordion_sub" role="listitem">
            <h4>Driver License Information</h4>
          </li>

          <li role="listitem">
            <span>
              <b>DL #</b>
            </span>
            <span>{profileData.drivers_license ?? '-'}</span>
            <EditProfile
              label="DL #"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors) => (
                <>
                  <label>DL #</label>
                  <input
                    {...register('drivers_license', {
                      maxLength: {
                        value: 20,
                        message:
                          'Length exceeds the maximum limit of 20 characters.',
                      },
                      pattern: {
                        value: /^[A-Za-z0-9]+$/, // Regex for alphabets and numbers
                        message: 'Only alphabets and numbers are allowed.',
                      },
                    })}
                    placeholder="Enter Drivers License #"
                    defaultValue={profileData.drivers_license}
                    className={
                      errors.drivers_license && 'profile-form-field-error'
                    }
                  />
                  {errors.drivers_license && (
                    <p className="error-message">
                      {errors.drivers_license.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>Driver's License State Issued</b>
            </span>
            <span>{profileData.DLState ? profileData.DLState : '-'}</span>
            <EditProfile
              label="Driver License State"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors) => (
                <>
                  <label>Driver License State</label>
                  <input
                    {...register('driver_license_state', {
                      maxLength: {
                        value: 20,
                        message:
                          'Length exceeds the maximum limit of 20 characters.',
                      },
                      pattern: {
                        value: /^[A-Za-z ]+$/,
                        message: 'Only alphabets are allowed.',
                      },
                    })}
                    placeholder="Enter Driver License State"
                    defaultValue={profileData.DLState}
                    className={
                      errors.driver_license_state && 'profile-form-field-error'
                    }
                  />
                  {errors.driver_license_state && (
                    <p className="error-message">
                      {errors.driver_license_state.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>Driver's License Expiration Date</b>
            </span>
            <span>{formatDate(profileData.dl_expiry)}</span>
            <EditProfile
              label="Driver's License Expiration Date"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Driver's License Expiration Date</label>
                  <Controller
                    name="dl_expiry"
                    control={control}
                    defaultValue={
                      profileData.dl_expiry
                        ? moment(profileData.dl_expiry).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date
                                .startOf('day')
                                .isBefore(moment().startOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        showMonthDropdown
                        showYearDropdown
                        minDate={moment()}
                        placeholderText="Select Expiry Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.dl_expiry && (
                    <p className="error-message">{errors.dl_expiry.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li class="accordion_sub" role="listitem">
            <h4>Insurance Status</h4>
          </li>

          <li role="listitem">
            <span>
              <b>Insurance Date Check</b>
            </span>
            <span>{formatDate(profileData.insurance_check_status_date)}</span>
            <EditProfile
              label="Insurance Date Check"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Insurance Date Check</label>
                  <Controller
                    name="insurance_check_status_date"
                    control={control}
                    defaultValue={
                      profileData.insurance_check_status_date
                        ? moment(
                            profileData.insurance_check_status_date
                          ).format(dateTimeConstants.DATE_FORMAT)
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Insurance Check Status Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.insurance_check_status_date && (
                    <p className="error-message">
                      {errors.insurance_check_status_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>Insurance</b>
            </span>
            <span
              className={
                insuranceCheckStatus[profileData.insurance_check_status] ==
                DENIED_STATUS
                  ? 'expired'
                  : ''
              }
            >
              {profileData.insurance_check_status &&
              profileData.insurance_check_status_date
                ? insuranceCheckStatus[profileData.insurance_check_status] +
                  ' on ' +
                  formatDate(profileData.insurance_check_status_date)
                : '-'}
            </span>
            <EditProfile
              label="Insurance"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Insurance</label>
                  <select
                    {...register('insurance_check_status')}
                    defaultValue={profileData.insurance_check_status}
                    className={
                      errors.insurance_check_status &&
                      'profile-form-field-error'
                    }
                  >
                    <option value="">Select Insurance Check Status</option>
                    <option value="1">Approved</option>
                    <option value="2">Denied</option>
                  </select>
                  {errors.insurance_check_status && (
                    <p className="error-message">
                      {errors.insurance_check_status.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>Driver Pin</b>
            </span>
            <span>{profileData.driver_pin ?? '-'}</span>
            <EditProfile
              label="Driver Pin"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors) => (
                <>
                  <label>Driver Pin</label>
                  <input
                    {...register('driver_pin', {
                      maxLength: {
                        value: 10,
                        message:
                          'Length exceeds the maximum limit of 10 characters.',
                      },
                      pattern: {
                        value: /^[A-Za-z0-9]+$/, // Regex for alphabets and numbers
                        message: 'Only alphabets and numbers are allowed.',
                      },
                    })}
                    placeholder="Enter Driver Pin"
                    defaultValue={profileData.driver_pin}
                    className={errors.driver_pin && 'profile-form-field-error'}
                  />
                  {errors.driver_pin && (
                    <p className="error-message">{errors.driver_pin.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li class="accordion_sub" role="listitem">
            <h4>Department of Transportation Information</h4>
          </li>

          <li role="listitem">
            <span>
              <b>Has Commercial Drivers License?</b>
            </span>
            <span>
              {profileData.commercial_drivers_license_check == 1
                ? 'Yes'
                : profileData.commercial_drivers_license_check == 0
                  ? 'No'
                  : '-'}
            </span>
            <EditProfile
              label="Has Commercial Drivers License?"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Expiry/Assigned Dates'
              )}
            >
              {(register, errors, setValue, control, watch) => {
                const watchCDL = watch('commercial_drivers_license_check');

                useEffect(() => {
                  if (watchCDL === '0' || watchCDL === '') {
                    setValue('dot_preemployment_drug_screen_date', '');
                    setValue('dot_clearinghouse', '');
                    setValue('physical_expiry', '');
                    setValue('dmv_pull_notice_date', '');
                  }
                }, [watchCDL, setValue]);

                const hasCDL =
                  watchCDL !== undefined
                    ? watchCDL === '1'
                    : String(profileData.commercial_drivers_license_check) ===
                      '1';

                return (
                  <>
                    <label>Has Commercial Drivers License?</label>
                    <select
                      {...register('commercial_drivers_license_check', {
                        required:
                          'Commercial Drivers License check is required',
                      })}
                      defaultValue={
                        profileData.commercial_drivers_license_check
                      }
                      className={
                        errors.commercial_drivers_license_check &&
                        'profile-form-field-error'
                      }
                    >
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                    {errors.commercial_drivers_license_check && (
                      <p className="error-message">
                        {errors.commercial_drivers_license_check.message}
                      </p>
                    )}

                    <label>DOT Pre-employment Drug Screen Date</label>
                    <Controller
                      name="dot_preemployment_drug_screen_date"
                      control={control}
                      defaultValue={
                        profileData.dot_preemployment_drug_screen_date
                          ? moment(
                              profileData.dot_preemployment_drug_screen_date
                            ).format(dateTimeConstants.DATE_FORMAT)
                          : null
                      }
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          selected={value ? moment(value) : ''}
                          onChange={(date) =>
                            onChange(
                              date &&
                                !date
                                  .startOf('day')
                                  .isBefore(moment().startOf('day'))
                                ? date.format(dateTimeConstants.DATE_FORMAT)
                                : ''
                            )
                          }
                          disabled={!hasCDL}
                          customInput={<input inputMode="none" />}
                          minDate={moment()}
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select DOT Pre-employment Drug Screen Date"
                          className={error ? 'profile-form-field-error' : ''}
                          dateFormat={dateTimeConstants.DATE_FORMAT}
                          showPopperArrow={false}
                        />
                      )}
                    />
                    {errors.dot_preemployment_drug_screen_date && (
                      <p className="error-message">
                        {errors.dot_preemployment_drug_screen_date.message}
                      </p>
                    )}

                    <label>DOT Clearinghouse Date</label>
                    <Controller
                      name="dot_clearinghouse"
                      control={control}
                      defaultValue={
                        profileData.dot_clearinghouse
                          ? moment(profileData.dot_clearinghouse).format(
                              dateTimeConstants.DATE_FORMAT
                            )
                          : null
                      }
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          selected={value ? moment(value) : ''}
                          onChange={(date) =>
                            onChange(
                              date &&
                                !date
                                  .startOf('day')
                                  .isBefore(moment().startOf('day'))
                                ? date.format(dateTimeConstants.DATE_FORMAT)
                                : ''
                            )
                          }
                          disabled={!hasCDL}
                          customInput={<input inputMode="none" />}
                          minDate={moment()}
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select DOT Clearinghouse Date"
                          className={error ? 'profile-form-field-error' : ''}
                          dateFormat={dateTimeConstants.DATE_FORMAT}
                          showPopperArrow={false}
                        />
                      )}
                    />
                    {errors.dot_clearinghouse && (
                      <p className="error-message">
                        {errors.dot_clearinghouse.message}
                      </p>
                    )}

                    <label>DOT/DMV Physical Expiration Date</label>
                    <Controller
                      name="physical_expiry"
                      control={control}
                      defaultValue={
                        profileData.physical_expiry
                          ? moment(profileData.physical_expiry).format(
                              dateTimeConstants.DATE_FORMAT
                            )
                          : null
                      }
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          selected={value ? moment(value) : ''}
                          onChange={(date) =>
                            onChange(
                              date &&
                                !date
                                  .startOf('day')
                                  .isBefore(moment().startOf('day'))
                                ? date.format(dateTimeConstants.DATE_FORMAT)
                                : ''
                            )
                          }
                          disabled={!hasCDL}
                          customInput={<input inputMode="none" />}
                          minDate={moment()}
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select DOT/DMV Physical Expiration Date"
                          className={error ? 'profile-form-field-error' : ''}
                          dateFormat={dateTimeConstants.DATE_FORMAT}
                          showPopperArrow={false}
                        />
                      )}
                    />
                    {errors.physical_expiry && (
                      <p className="error-message">
                        {errors.physical_expiry.message}
                      </p>
                    )}

                    <label>DMV Pull Notice Date</label>
                    <Controller
                      name="dmv_pull_notice_date"
                      control={control}
                      defaultValue={
                        profileData.dmv_pull_notice_date
                          ? moment(profileData.dmv_pull_notice_date).format(
                              dateTimeConstants.DATE_FORMAT
                            )
                          : null
                      }
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          selected={value ? moment(value) : ''}
                          onChange={(date) =>
                            onChange(
                              date &&
                                !date
                                  .startOf('day')
                                  .isBefore(moment().startOf('day'))
                                ? date.format(dateTimeConstants.DATE_FORMAT)
                                : ''
                            )
                          }
                          disabled={!hasCDL}
                          customInput={<input inputMode="none" />}
                          minDate={moment()}
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select DMV Pull Notice Date"
                          className={error ? 'profile-form-field-error' : ''}
                          dateFormat={dateTimeConstants.DATE_FORMAT}
                          showPopperArrow={false}
                        />
                      )}
                    />
                    {errors.dmv_pull_notice_date && (
                      <p className="error-message">
                        {errors.dmv_pull_notice_date.message}
                      </p>
                    )}
                  </>
                );
              }}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>DOT Pre-employment Drug Screen Date</b>
            </span>
            <span>
              {formatDate(profileData.dot_preemployment_drug_screen_date)}
            </span>
          </li>

          <li role="listitem">
            <span>
              <b>DOT Clearinghouse Date</b>
            </span>
            <span>{formatDate(profileData.dot_clearinghouse)}</span>
          </li>

          <li role="listitem">
            <span>
              <b>DOT/DMV Physical Expiration Date</b>
            </span>
            <span>{formatDate(profileData.physical_expiry)}</span>
          </li>

          <li role="listitem">
            <span>
              <b>DMV Pull Notice Date</b>
            </span>
            <span>{formatDate(profileData.dmv_pull_notice_date)}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DriverQualificationsComponent;
